import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lp2-private-class-without-track-banner',
  styleUrls: ['./private-class-without-track-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section class="position-relative">
      <lp2-private-class-left-header-banner reducedBannerWidth="true" imageUrl="/images/private-classes/largeImage.png">
        <ng-container withoutTrack>
          <div class="text-center text-xl-left mt-xl-3">
            <p class="w-100 fs-4 text-content">
              {{ 'oeapp.studybundle.pc.newAccess.title' | translate }}
            </p>
            <p class="w-100 text-content">
              {{ 'oeapp.studybundle.pc.newAccess.description' | translate }}
            </p>
            <a class="d-inline-block btn-accent-contained mb-3" href="/private-classes.html">{{
              'oeapp.studybundle.pc.newAccess.button' | translate
            }}</a>
          </div>
        </ng-container>
      </lp2-private-class-left-header-banner>
      <div class="bigImageContainer py-5 d-none d-xl-inline-block">
        <img class="bigImage" src="/images/private-classes/largeImage.png" />
      </div>
    </section>
  `,
})
export class PrivateClassWithoutTrackBannerComponent {}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-without-track-banner/private-class-without-track-banner.component.ts